import { message, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  WalletManagementTable,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import * as XLSX from "xlsx";

export const WalletManagement = () => {
  const [modal, setModal] = useState({
    customer: false,
    referral: false,
    earnings: false,
    result: false,
  });
  // const [formData, setFormData] = useState({});
  const [totalWalletBalance, setTotalWalletBalance] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [redeemThreshold, setRedeemThreshold] = useState();
  const [specialEarning, setSpecialEarning] = useState();
  const [specialEarningData, setSpecialEarningData] = useState();
  const [reActivationData, setReActivationData] = useState();
  const [customerID, setCustomerID] = useState();
  const [customerBalance, setCustomerBalance] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const [earningInfo, setEarningInfo] = useState([]);
  const [viewInfo, setViewInfo] = useState({});
  const columns = [
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Date Changed",
      dataIndex: "createdAt",
      key: "createdAt",
    },
  ];

  const specialEarningsPayout = [
    {
      title: "Activity ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      dataIndex: "imageUrl",
      key: "action",
      render: (link, record) => (
        <Button
          color="primary"
          size="md"
          onClick={() => {
            // open new Modal
            setModal({ earnings: false, result: true });
            onViewEarningClick(link);
            setViewInfo({ fileName: record?.fileName, date: record?.createdAt });
          }}
        >
          View
        </Button>
      ),
    },
  ];

  const onViewEarningClick = async (link) => {
    var req = new XMLHttpRequest();
    req.open("get", link, true);
    req.responseType = "arraybuffer";
    req.onload = () => {
      const res = req.response;
      var workbook = XLSX.read(res, { type: "array" });
      const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      // console.log(data)
      setEarningInfo(
        data?.map((result) => ({
          userId: result["USER ID"],
          amount: result["AMOUNT"],
          description: result["DESCRIPTION"],
          status: result["STATUS"] || result["__EMPTY"] || result["Status"],
        }))
      );
    };
    req.send();
  };

  const getTotalWalletBalance = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/wallets/get-total-wallet-balance`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setTotalWalletBalance(resultData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const getCustomerWalletBalance = async (customerID) => {
    try {
      setBtnLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/admin/wallets/get-customer-wallet-balance/${customerID}`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data;
      setCustomerBalance(resultData.toString());
      if (resultData) {
        setBtnLoading(false);
      }
    } catch (error) {
      setModal({ customer: false });
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };

  const [referralSetting, setReferralSetting] = useState();

  const [activationBonusActivities, setActivationBonusActivities] = useState();
  const [activationBonus, setActivationBonus] = useState();

  const getActivationBonus = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/wallets/get-activation-referral-bonus`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data;
      setActivationBonus(resultData);
    } catch (error) {
      setModal({ customer: false });
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const getActivationBonusActivities = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/wallets/get-activation-referral-bonus/activities`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data.entities;
      setActivationBonusActivities(resultData);
    } catch (error) {
      setModal({ customer: false });
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const [activationAmount, setActivationAmount] = useState();
  const handleActivationBonus = async (amount) => {
    const obj = {};
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/wallets/set-activation-referral-bonus/?amount=${amount}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        setModal({ referral: false });
        setActivationAmount(undefined);
        setReferralSetting(undefined);
        getActivationBonusActivities();
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const err = error.response;
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const [reActivationBonusActivities, setReActivationBonusActivities] = useState();
  const [reActivationBonus, setReActivationBonus] = useState();
  const getReActivationBonus = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/wallets/get-reactivation-referral-bonus`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data;
      setReActivationBonus(resultData);
    } catch (error) {
      setModal({ customer: false });
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getReActivationBonusActivities = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/wallets/get-reactivation-referral-bonus/activities`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data.entities;
      setReActivationBonusActivities(resultData);
    } catch (error) {
      setModal({ customer: false });
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReActivationBonus = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/wallets/set-reactivation-referral-bonus`,
        data,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        setModal({ referral: false });
        setReActivationData(undefined);
        setReferralSetting(undefined);
        getReActivationBonusActivities();
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const err = error.response;
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getReferralRedeemTreshold = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/wallets/get-referral-redeem-threshold`,
        {
          headers: authHeader(),
        }
      );
      const resultData = response.data.amount;
      setRedeemThreshold(resultData);
    } catch (error) {
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const handleRedeemThreshold = async (threshold) => {
    const obj = {};
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/wallets/set-referral-redeem-threshold/?amount=${threshold}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        setModal({ referral: false });
        setRedeemThreshold(undefined);
        setReferralSetting(undefined);
        getReferralRedeemTreshold()
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getSpecialEarning = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/special-earnings/payout-activities`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      setSpecialEarning(resultData);
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  function encodeSchedule(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setSpecialEarningData({
          base64encodedUpload: url,
          fileName: filename,
        });
      }
    };
    reader.readAsDataURL(file);
  }

  const handleSpecialEarningUpload = async (obj) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/special-earnings/upload-schedule-payout`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        setModal({ earnings: false });
        setSpecialEarningData(undefined);
        setReferralSetting(undefined);
        getSpecialEarning();
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const err = error.response;
      setModal({ earnings: false });
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onFormCancel = () => {
    setModal({ referral: false, earnings: false, customer: false });
    setReferralSetting(undefined);
  };

 

  const customerWalletBalance = () => {
    getCustomerWalletBalance(customerID);
  };


  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getTotalWalletBalance();
    getActivationBonusActivities();
    getActivationBonus();
    getReActivationBonus();
    getReActivationBonusActivities();
    getSpecialEarning();
    getReferralRedeemTreshold()
  }, []);

  return (
    <React.Fragment>
      <Head title="Project List"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Wallet Management</BlockTitle>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <WalletManagementTable
                totalAmount={Math.round(totalWalletBalance * 100) / 100}
                modal={modal}
                handleCustomerWalletBalance={() => setModal({ customer: true })}
                handleReferralSettings={() => setModal({ referral: true })}
                handleSpecialEarning={() => setModal({ earnings: true })}
              />
            )}
          </Card>
        </Block>

        <Modal
          isOpen={modal.customer}
          toggle={() => setModal({ customer: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Customer Wallet Balance</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(customerWalletBalance)}>
                  <Col md="12">
                    <FormGroup>
                      <input
                        type="text"
                        name="customerId"
                        placeholder="Input Customer ID"
                        onChange={(e) => setCustomerID(e.target.value)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <Button type="submit" color="primary" size="md">
                      {btnLoading ? <Spinner size="sm" /> : "Submit"}
                    </Button>
                  </Col>
                </Form>
              </div>
              <div className="mt-4">{customerBalance ? <h6>Customer Balance = {Math.round(customerBalance * 100) / 100}</h6> : null}</div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.referral}
          toggle={() => setModal({ referral: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Referral Bonus Settings</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Referral Bonus Setting</label>
                      <select className="form-control" onChange={(e) => setReferralSetting(e.target.value)}>
                        <option>Select...</option>
                        <option value="activation">Set Activation Referral Bonus</option>
                        <option value="reactivation">Set Reactivation Referral Bonus</option>
                        <option value="redeem_threshold">Set Referral Redeem Threshold</option>
                      </select>
                    </FormGroup>
                  </Col>
                  {referralSetting === "activation" ? (
                    <>
                      <Col md="6">
                        <FormGroup>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "NGN" }}
                            name="Amount"
                            defaultValue={activationBonus?.amount}
                            placeholder="Input Amount"
                            onValueChange={(value, name) => setActivationAmount(value)}
                            className="form-control"
                          />
                          {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        {activationAmount ? (
                          <Button onClick={() => handleActivationBonus(activationAmount)} color="primary" size="md">
                            Save
                          </Button>
                        ) : (
                          <Button disabled color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </Col>

                      <Table columns={columns} dataSource={activationBonusActivities} />
                    </>
                  ) : null}

                  {referralSetting === "reactivation" ? (
                    <>
                      <Col md="6">
                        <FormGroup>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "NGN" }}
                            name="Amount"
                            defaultValue={reActivationBonus?.amount}
                            placeholder="Input Amount"
                            onValueChange={(value, name) =>
                              setReActivationData({ ...reActivationData, amount: parseInt(value) })
                            }
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <input
                            type="number"
                            name="Poke Period"
                            defaultValue={reActivationBonus?.pokeValidityPeriodInHours}
                            placeholder="Input Poke Validity Period In Hours"
                            onChange={(e) =>
                              setReActivationData({
                                ...reActivationData,
                                pokeValidityPeriodInHours: parseInt(e.target.value),
                              })
                            }
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        {reActivationData ? (
                          <Button onClick={() => handleReActivationBonus(reActivationData)} color="primary" size="md">
                            Save
                          </Button>
                        ) : (
                          <Button disabled color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </Col>

                      <Table columns={columns} dataSource={reActivationBonusActivities} />
                    </>
                  ) : null}

                  {referralSetting === "redeem_threshold" ? (
                    <>
                      <Col md="6">
                        <FormGroup>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "NGN" }}
                            name="Minimum Amount"
                            placeholder="Minimum Amount"
                            value={redeemThreshold}
                            onValueChange={(value, name) => setRedeemThreshold(value)}
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        {redeemThreshold ? (
                          <Button onClick={() => handleRedeemThreshold(redeemThreshold)} color="primary" size="md">
                            Save
                          </Button>
                        ) : (
                          <Button disabled color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </Col>
                    </>
                  ) : null}
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.earnings}
          toggle={() => setModal({ earnings: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Upload Special Earning Payout Schedule</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="8">
                    <FormGroup>
                      <input
                        type="file"
                        name="specialEarningSchedule"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        className="form-control"
                        onChange={(e) => encodeSchedule(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    {specialEarningData ? (
                      <Button onClick={() => handleSpecialEarningUpload(specialEarningData)} color="primary" size="md">
                        Upload
                      </Button>
                    ) : (
                      <Button disabled color="primary" size="md">
                        Upload
                      </Button>
                    )}
                  </Col>
                </Form>
              </div>
              <div className="mt-4">
                <Table columns={specialEarningsPayout} dataSource={specialEarning} />
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={modal.result}
          toggle={() => setModal({ earnings: true, result: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setEarningInfo([]);
                setModal({ earnings: true, result: false });
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h6 style={{ fontSize: "0.9rem" }} className="mb-3">
                View Earning: [FileName: {viewInfo?.fileName} | Date: {viewInfo?.date}]
              </h6>
              <table className="table table-orders">
                <thead className="tb-odr-head">
                  <tr className="tb-odr-item">
                    <th>User ID</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="tb-odr-body">
                  {earningInfo &&
                    earningInfo.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td>{item?.userId}</td>
                          <td>{item.description}</td>
                          <td>{item?.amount}</td>
                          <td>
                            <span
                              className={`badge badge-dot badge-${item.status === "Successful" ? "success" : "danger"}`}
                            >
                              {item.status}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
